import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { smoothScrollTo } from './utils/smoothScroll';

const Nav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const menus = [
    { label: 'Tentang', href: '#tentang' },
    { label: 'Layanan', href: '#layanan' },
    { label: 'Produk', href: '#produk' },
    { label: 'Fitur', href: '#fitur' },
    { label: 'Tim', href: '#team' },
  ];

  const go = (href: string) => {
    setOpen(false);
    document.body.style.overflow = '';
    if (href.startsWith('#')) {
      const targetId = href.replace('#', '');

      // Jika sudah di homepage, cukup smooth scroll tanpa navigate ulang
      if (location.pathname === '/') {
        smoothScrollTo(targetId);
        return;
      }

      // Jika belum di homepage, navigate dulu lalu smooth scroll setelah render
      navigate('/');
      setTimeout(() => {
        smoothScrollTo(targetId);
      }, 200);
    } else {
      navigate(href);
    }
  };

  const toggle = () => {
    setOpen(!open);
    document.body.style.overflow = open ? '' : 'hidden';
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Jika hover, selalu tampilkan navbar
      if (isHovered) {
        setIsVisible(true);
        setLastScrollY(currentScrollY);
        return;
      }

      // Hide navbar saat scroll ke bawah, show saat scroll ke atas
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY, isHovered]);

  return (
    <>
      <header
        className="nav-wrapper"
        style={{
          transform: isVisible ? 'translateY(0)' : 'translateY(-100px)',
          opacity: isVisible ? 1 : 0,
          transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out'
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <nav className="nav-pill">
          <div className="nav-left" onClick={() => navigate('/')}
          >
            <img src="/tricipta.svg" alt="PT Tri Cipta Integra" />
            <span>PT. Tri Cipta Integra</span>
          </div>

          <ul className="nav-center">
            {menus.map((m) => (
              <li key={m.label} onClick={() => go(m.href)}>{m.label}</li>
            ))}
          </ul>

          <button className="burger" onClick={toggle} aria-label="Menu">
            <span />
            <span />
          </button>
        </nav>
      </header>

      {/* Mobile Sheet */}
      <div className={`mobile-sheet ${open ? 'open' : ''}`}>
        <div className="sheet-card">
          <div className="sheet-header">
            <img src="/tricipta.svg" alt="logo" />
            <button onClick={toggle}>×</button>
          </div>

          <ul className="sheet-menu">
            {menus.map((m) => (
              <li key={m.label} onClick={() => go(m.href)}>{m.label}</li>
            ))}
            <li onClick={() => go('/login')}>Log in</li>
          </ul>
        </div>
      </div>

      <style>{`
        .nav-wrapper{position:fixed;top:20px;left:0;right:0;display:flex;justify-content:center;z-index:1000}
        .nav-pill{display:flex;align-items:center;gap:40px;padding:14px 28px;border-radius:999px;background:#f5f5f4;box-shadow:0 10px 30px rgba(0,0,0,.1)}
        .nav-left{display:flex;gap:14px;align-items:center;font-weight:700;cursor:pointer}
        .nav-left img{height:44px}
        .nav-center{display:flex;gap:28px;list-style:none;margin:0;padding:0}
        .nav-center li{font-size:14px;cursor:pointer;opacity:.8;transition:opacity 0.2s ease, transform 0.2s ease}
        .nav-center li:hover{opacity:1;transform:translateY(-2px)}
        .nav-cta{background:#111827;color:#fff;border:0;padding:12px 22px;border-radius:999px;font-weight:600;cursor:pointer}
        .burger{display:none;background:none;border:0;gap:6px;flex-direction:column;cursor:pointer}
        .burger span{width:22px;height:2px;background:#111827}

        .mobile-sheet{position:fixed;inset:0;background:rgba(0,0,0,.4);backdrop-filter:blur(4px);opacity:0;pointer-events:none;transition:.3s;z-index:1100}
        .mobile-sheet.open{opacity:1;pointer-events:auto}
        .sheet-card{position:absolute;top:12px;left:12px;right:12px;background:#fafafa;border-radius:24px;padding:20px;box-shadow:0 20px 40px rgba(0,0,0,.2)}
        .sheet-header{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px}
        .sheet-header img{height:28px}
        .sheet-header button{font-size:22px;background:none;border:0;cursor:pointer}
        .sheet-menu{list-style:none;padding:0;margin:0 0 20px 0}
        .sheet-menu li{padding:14px 8px;font-size:16px;font-weight:500;cursor:pointer}
        .sheet-cta{width:100%;background:#111827;color:#fff;border:0;padding:14px;border-radius:999px;font-weight:600}

        @media(max-width:768px){
          .nav-center,.nav-cta{display:none}
          .burger{display:flex}
        }
      `}</style>
    </>
  );
};

export default Nav;
